import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { AfterViewInit, Injector } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Transaction } from '@models/transaction';
import { TransactionDto } from '@dto/transactionDto';
import { TransactionSuccess } from '@enums/transaction-success.enum';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TransactionsService } from '@services/entity/transactions.service';
import { FilesService } from '@services/files/files.service';
import { FormService } from '@services/form/form.service';
import { ToastService } from '@services/toast/toast.service';
import { Chart, ChartConfiguration, ChartData, registerables } from 'chart.js';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { TransactionMeterValuesChartData } from '@models/TransactionMeterValuesChartData';

@Component({
  selector: 'app-details-transaction-dialog-content',
  templateUrl: './details-transaction-dialog-content.component.html',
  styleUrls: ['./details-transaction-dialog-content.component.scss']
})
export class DetailsTransactionDialogContentComponent extends AbstractDialogContent implements OnInit, AfterViewInit {

  public className = 'DetailsTransactionDialogContentComponent';

  @ViewChild('detailsTransaction') detailsTransaction;

  public entity: TransactionDto;

  public customerId: number;

  public fileExists: boolean;

  chartIsLoading = false;
  public chart: Chart;
  public canvas: any;
  public ctx: any;

  constructor(
    public activeModal: NgbActiveModal,
    private filesService: FilesService,
    private transactionsService: TransactionsService,
    public toastService: ToastService,
    injector: Injector) {
    super(activeModal, injector);
  }


  ngOnInit() {
    super.ngOnInit();


  }

  ngAfterViewInit(): void {
  }



  async onEntityLoadedEvent(entity: TransactionDto) {
    if (!entity) return
    this.entity = entity;

    this.getTransactionMeterValuesChartDatas();

    this.entity.successMessage = TransactionSuccess[entity.success];
    this.checkIfFileExists();

    if (!this.entity?.meterAmount) {
      this.transactionsService.getKwhOfRunningTransaction(entity.transactionId).subscribe(kWh=>{
        this.entity.meterAmount = kWh;
      })
    }
  }

  getTransactionMeterValuesChartDatas(): Promise<TransactionMeterValuesChartData[] | null> {
    return new Promise((resolve, reject) => {
      this.transactionsService.getTransactionMeterValuesChartDatas(this.entity.transactionId).subscribe(
        tmvcd => {
          if (tmvcd?.length) {
            document.getElementById('MeterValuesChart').style.display = 'block';
            this.createChartData(tmvcd);
            resolve(tmvcd);
          } else {
            document.getElementById('MeterValuesChart').style.display = 'none';
            resolve(null);
          }
        },
        error => {
          console.error('Fehler beim Abrufen oder Verarbeiten der Daten:', error);
          document.getElementById('MeterValuesChart').style.display = 'none';
          reject(error);
        }
      );
    });
  }

  setMeterAmountByChartDatas() {

  }




  checkIfFileExists() {
    var fileName = 'signedMeterValues/' + this.entity.id + '-signedMeterValue.xml';

    this.filesService.fileExists(fileName).subscribe(result => {
      this.fileExists = result;
    })
  }

  downloadSignedMeterValues() {
    if (this.fileExists) {
      var fileName = 'signedMeterValues/' + this.entity.id + '-signedMeterValue.xml';
      var downloadFileName = this.entity.id + '-signedMeterValue.xml';
      this.filesService.download(fileName, downloadFileName);
      this.toastService.success('Die signierte Datei wird erfolgreich heruntergeladen!')
      this.activeModal.close()
    }
  }


  createChartData(dataPoints: TransactionMeterValuesChartData[]) {
    dataPoints.forEach(item => {
      item.timestamp = new Date(item.timestamp);
    });

    dataPoints.sort((a, b) => a.timestamp.getTime() - b.timestamp.getTime());

    const transformedDataPoints = dataPoints.map(point => {

      let timestamp = point.timestamp;
      if (!(timestamp instanceof Date)) {
        timestamp = new Date(timestamp);
      }

      return {
        x: timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        y: point.powerInkW
      };
    });

    this.createChart(transformedDataPoints);
  }

  createChart(dataPoints: { x: string, y: number }[]): void {
    if (this.chart) {
      this.chart.destroy();
    }
    const ctx = document.getElementById('distribution-chart-canvas') as HTMLCanvasElement;

    const chartData: ChartData<'line', { x: string, y: number }[]> = {
      datasets: [
        {
          data: dataPoints,
          borderColor: 'rgba(7, 181, 245, 1)',
          backgroundColor: 'rgba(75, 192, 192, 0.2)',
          fill: false,
          pointRadius: 0 // Make data points invisible
        }
      ]
    };

    const config: ChartConfiguration<'line', { x: string, y: number }[]> = {
      type: 'line',
      data: chartData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            type: 'category', // Use category scale since x values are strings
            title: {
              display: true,
              text: 'Uhrzeit'
            }
          },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Leistung in kW'
            }
          }
        },
        plugins: {
          legend: {
            display: false // Disable the legend
          }
        }
      }
    };

    this.chart = new Chart(ctx, config as any);
  }

  updateChart(newDataPoints: { x: string, y: number }[]): void {
    this.createChart(newDataPoints);
  }












}
